import type {
  AppContext,
  Slot,
  SlotExtended
} from "@/types/scheduling";

import { groupBy } from "ramda";

export const handleAssignSlots = <T extends AppContext>(context: T, params: { slots: Slot[] }) => {
  const { slots } = params;
  const slotsExtended: SlotExtended[] = slots.map((slot) => {
    const shortDate = slot.date.split(" ")[0];
    return {
      ...slot,
      short_date: shortDate,
    }
  });

  const byRDE = groupBy((slot: SlotExtended) => slot.user_id);
  const grouppedByRDE = byRDE(slotsExtended);
  const rdes = Object.keys(grouppedByRDE);

  return {
    ...context,
    slots: slotsExtended,
    pulled_provider_ids: rdes
  };
}
